import {Enum} from 'enumify';

class AccountViewTypeEnum extends Enum{}

    AccountViewTypeEnum.initEnum({
            AccountWithoutSentShipment: 'accountWithoutSentShipment',
            AccountWithoutReceivedPackage: 'accountWithoutReceivedPackage',
            AccountSortBySentShipments: 'accountSortBySentShipments',
            AccountSortByRevenue: 'accountSortByRevenue',
            InactiveAccountForTimePeriod: 'inactiveAccountForTimePeriod',
            ShipmentsWithCoupons: 'shipmentsWithCoupons',
            SentShipmentsByMonth: 'sentShipmentsByMonth',
        }
     );

export default AccountViewTypeEnum;